import { ACTIONS, INITIAL_STATE, START_OVER_STATE, DEFAULT_STATE_VALUE, DEFAULT_ATTR_VALUE } from '../constants.js'
import { filter } from './utils'
import { param2sku, sku2array } from '../logic/sku-ver3.js'
import { get_default_sku } from './utils'
import { rules_sh } from './rules_sh'
import { rules_headc, alt } from './rules_headc'
import { rules_rsetc, alt2 } from './rules_rsetc'
import { rules_rmet } from './rules_rmet'
import { rules_dctw } from './rules_dctw'
import { check_default, check_default_max } from './rules_functions'

function checkNewValue(state,newstate,value) {
  if (value in newstate) return newstate[value]
  return state[value]
}

export var crosssku, crossurl/* , crossprices
var lastsku = '' */

var DEFAULT_DICT = DEFAULT_ATTR_VALUE['R3']
var lastCS = get_default_sku()
//var tdict
export var changed = false

var cdict = {
    // R | P E B
  'R1': [[8,1], [1,8], [1,3]], 'R2': [[3,2], [1,7], [2,3]], 'R3': [[5,1], [1,2], [4,3]], 'R4': [[1,3], [1,8], [1,3]], 'R5': [[5,2], [3,8], [1,3]], 'R6': [[5,3], [6,1], [1,3]],
    'R7': [[7,6], [5,3], [4,3]], 'R8': [[1,2], [1,2], [1,3]], 'R9': [[1,3], [1,8], [1,3]], 'R10': [[2,3], [8,7], [2,3]], 'R11': [[6,5], [5,7], [4,3]],'R12': [[1,2], [1,2], [1,2]],
    // P | R E B
  'P1': [[4,1], [1,2], [1,3]], 'P2': [[2,9], [5,7], [4,3]], 'P3': [[10,9], [6,7], [2,3]], 'P4': [[1,2], [1,2], [1,3]], 'P5': [[6,3], [3,2], [1,3]], 'P6': [[11,7], [3,5], [4,3]],
    'P7': [[7,11], [5,7], [1,3]], 'P8': [[5,1], [8,6], [4,3]],'P9': [[1,2], [1,2], [1,2]],
    // E | R P B
  'E1': [[4,2], [1,3], [1,3]], 'E2': [[1,3], [5,1], [1,3]], 'E3': [[11,5], [6,5], [2,3]], 'E4': [[1,2], [1,2], [1,3]], 'E5': [[7,11], [7,6], [4,3]], 'E6': [[6,2], [1,3], [2,3]],
    'E7': [[9,10], [1,3], [4,3]], 'E8': [[3,1], [8,1], [1,3]],
    // B | R P E
  'B1': [[1,2], [8,2], [1,8]], 'B2': [[4,5], [5,3], [5,7]], 'B3': [[11,9], [3,1], [1,6]], 'B4': [[3,6], [2,1], [8,6]]
}
  

/* function genCS(sh) {
  var cslist = []
  Object.keys(tdict).forEach(type => {
    if (sh.substring(0,1) !== type) {
      let cs1 = Math.floor(Math.random() * tdict[type]) + 1, cs2 = Math.floor(Math.random() * tdict[type]) + 1
      if (cs2 >= cs1)
        cs2 = Math.max((cs2 + 1) % tdict[type], 1)
      if (cs2 === cs1)
        cs2 += 1
      let cs = [type + cs1, type + cs2]
      cs.sort()
      cslist.push(cs)
    }
  })
  cdict[sh] = cslist
} */

function genSku(arr, dict, gems, mets) {
  var carr = ['WT','AQ','CT','PZ','LBT','AM','RH','TZ','PT']
  var harr1 = ['D','WT','CT','PZ','AM','GA','PT','SAP','EM','RU']
  var harr2 = ['WT','AQ','CT','PZ','LBT','AM','MG','TZ','PT']
  var sdict = {'D':'WT', 'GA':'PT', 'SAP':'TZ', 'EM':'PZ', 'RU':'PT', 'AQ':'WT', 'LBT':'SAP', 'MG':'PT', 'TZ':'SAP', 'RH':'PT'}
  var cec2, headc, rsetc, hmet, rmet, rs2, bl2
  var ctw = arr[3]
  var crsh = arr[7]
  var shape = arr[2]

  if (crsh === 'P8' && shape === 'HECU')
    shape = 'HCU'
  else if (crsh === 'B4' && shape === 'HPS')
    shape = 'HOV'

  if (['P2','P3','P6','E2'].includes(crsh) && ['D','WT'].includes(gems[0])) {
    gems = gems.reverse()
  }
  else if (crsh === 'P8' && gems.length < 2) {
    gems.push('WT')
    gems = gems.reverse()
  }

  if (dict['cec2'] !== '0') {
    if (gems.length === 0) {
      cec2 = 'WT'
    }
    else if (carr.includes(gems[0])) {
      cec2 = gems[0]
    }
    else {
      cec2 = sdict[gems[0]]
    }
  }
  if (dict['headc'] !== '0') {
    if (gems.length === 0) {
      headc = 'WT'
    }
    else if (!alt.includes(crsh)) {
      if (harr1.includes(gems[0])) {
        headc = gems[0]
      }
      else {
        headc = sdict[gems[0]]
      }
    }
    else {
      if (harr2.includes(gems[0])) {
        if (crsh === 'E8' && ((gems[0] === 'MG') || (gems[0] === 'RH')))
          headc = 'PT'
        else if (crsh === 'E8' && ['AQ', 'LBT', 'TZ'].includes(gems[0]))
          headc = 'WT'
        else
          headc = gems[0]
      }
      else {
        if (crsh === 'E8' && ((sdict[gems[0]] === 'MG') || (sdict[gems[0]] === 'RH')))
          headc = 'PT'
        else if (crsh === 'E8' && ['AQ', 'LBT', 'TZ'].includes(sdict[gems[0]]))
          headc = 'WT'
        else
          headc = sdict[gems[0]]
      }
    }
  }
  if (dict['rsetc'] !== '0') {
    if (gems.length > 1 || dict['headc'] === '0') {
      if (!alt2.includes(crsh)) {
        if (harr1.includes(gems[0])) {
          rsetc = gems[0]
        }
        else {
          rsetc = sdict[gems[0]]
        }
      }
      else {
        if (harr2.includes(gems[0])) {
          rsetc = gems[0]
        }
        else {
          rsetc = sdict[gems[0]]
        }
      }
    }
    else {
      if (rsetc === undefined)
        rsetc = 'WT'
    }
  }

  if (ctw !== '1') {
    if (['R','P'].includes(arr[0]) && crsh !== 'P8' && arr[2] === 'HPS')
      ctw = '3'
    else
      ctw = '2'
  }

  if (dict['hmet'] === '0') {
    hmet = '0'
    rmet = mets[mets.length - 1]
  }
  else if (mets.length === 1) {
    hmet = mets[0]
    rmet = mets[0]
  }
  else {
    hmet = mets[0]
    rmet = mets[1]
  }

  if (arr[0] !== 'R')
    rs2 = '0'
  else
    rs2 = arr[4]

  if (arr[0] !== 'B')
    bl2 = '0'
  else
    bl2 = arr[5]

  if (arr[0] === 'B') {
    if (hmet.includes('14'))
      hmet = hmet.replace('14','10')
    if (rmet.includes('14'))
      rmet = rmet.replace('14','10')
  }

  return param2sku([arr[0], arr[1], cec2, shape, ctw, headc, rsetc, hmet, rmet, rs2, bl2, arr[6], crsh])
}

function genCrossSell(state) {
  /* if (lastCS === undefined)
    lastCS = get_default_sku() */
  //console.log('gen', state.sku, lastCS)
  if (state.sku === lastCS &&crossurl !== undefined) // || state.sku === DEFAULT_K_SKU)
    return

  var cross, cross1, cross2, cross3

  if (state['type'] === '0')
    return [['',''], ['',''], ['','']]

  var gems = []
  if (state['cec2'] !== '0')
    gems.push(state['cec2'])
  if (state['headc'] !== '0' && DEFAULT_ATTR_VALUE[state.sh]['headc']!=='0') //state['options_headc'].show)
    gems.push(state['headc'])
  if (state['rsetc'] !== '0')
    gems.push(state['rsetc'])

  var mets = []
  if (state['hmet'] !== '0')
    mets.push(state['hmet'])
  if (state['rmet'] !== '0')
    mets.push(state['rmet'])

  cross = ['R', 'P', 'E', 'B']
  cross.splice(cross.indexOf(state['sh'].substring(0,1)),1)

  cross1 = cdict[state['sh']][0]
  cross2 = cdict[state['sh']][1]
  cross3 = cdict[state['sh']][2]
  cross1 = [cross[0]+cross1[0],cross[0]+cross1[1]]
  cross2 = [cross[1]+cross2[0],cross[1]+cross2[1]]
  cross3 = [cross[2]+cross3[0],cross[2]+cross3[1]]

  var cross11 = genSku([cross[0],state['cec'],state['ds'],state['dctw'],state['rs2'],state['bl2'],state['store'],cross1[0]],DEFAULT_ATTR_VALUE[cross1[0]],gems,mets)
  var cross12 = genSku([cross[0],state['cec'],state['ds'],state['dctw'],state['rs2'],state['bl2'],state['store'],cross1[1]],DEFAULT_ATTR_VALUE[cross1[1]],gems,mets)
  var cross21 = genSku([cross[1],state['cec'],state['ds'],state['dctw'],state['rs2'],state['bl2'],state['store'],cross2[0]],DEFAULT_ATTR_VALUE[cross2[0]],gems,mets)
  var cross22 = genSku([cross[1],state['cec'],state['ds'],state['dctw'],state['rs2'],state['bl2'],state['store'],cross2[1]],DEFAULT_ATTR_VALUE[cross2[1]],gems,mets)
  var cross31 = genSku([cross[2],state['cec'],state['ds'],state['dctw'],state['rs2'],state['bl2'],state['store'],cross3[0]],DEFAULT_ATTR_VALUE[cross3[0]],gems,mets)
  var cross32 = genSku([cross[2],state['cec'],state['ds'],state['dctw'],state['rs2'],state['bl2'],state['store'],cross3[1]],DEFAULT_ATTR_VALUE[cross3[1]],gems,mets)
  crossurl = []
  crosssku = [cross11[0], cross12[0], cross21[0], cross22[0], cross31[0], cross32[0]]

  //loadPrices(crosssku.join(','))

  crossurl.push([cross[0], '//bridalimages.thepersonalizedbest.com/bridal_imageFJC/'+cross11[0]+'.jpg?v=1', '//bridalimages.thepersonalizedbest.com/bridal_imageFJC/'+cross12[0]+'.jpg?v=1'])
  crossurl.push([cross[1], '//bridalimages.thepersonalizedbest.com/bridal_imageFJC/'+cross21[0]+'.jpg?v=1', '//bridalimages.thepersonalizedbest.com/bridal_imageFJC/'+cross22[0]+'.jpg?v=1'])
  crossurl.push([cross[2], '//bridalimages.thepersonalizedbest.com/bridal_imageFJC/'+cross31[0]+'.jpg?v=1', '//bridalimages.thepersonalizedbest.com/bridal_imageFJC/'+cross32[0]+'.jpg?v=1'])

  lastCS = state['sku']
}

/* function loadPrices(cslist) {
  if (cslist === lastsku)
    return
  else
    lastsku = cslist

  if (cslist === undefined)
    return

  let fetchUrl = PRICE_URL
  if (window.currentEnv === 'www')
    fetchUrl = PRICE_URL_PROD
  
  let header = new Headers({'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data'});
  let sentData = {method: 'GET', mode: 'cors', header: header};
  
  fetch(fetchUrl + cslist, sentData)
    .then(response => {
    if (response.ok)
      return response.json();
    else {
      this.setState({error: true})
      this.messages.show({severity: 'error', sticky: true, summary: 'Error loading item info: ', detail: 'Cannot load data'});
      throw new Error('Something went wrong ...');
    }
    })
    .then(json => {
    if (Object.keys(json).length === 0) {
      this.setState({error: true})
      this.messages.show({severity: 'error', sticky: true, summary: 'Error loading item info: ', detail: 'No load data'});
      throw new Error('Something went wrong ...');
    }
    if (crossprices === undefined) {
      lastsku = ''
      crossprices = json.flatMap(x => x['p'])
      setTimeout(loadPrices(cslist), 500)
    }
    else
      crossprices = json.flatMap(x => x['p'])
    }
  )
} */

/* function initCS(state) {
  if (tdict === undefined) {
    tdict = {}
    var shlist = state['options_sh'].options.flatMap(x => x['value'].substring(0,1))
    for(var i = 0; i < shlist.length; ++i) {
      if(!tdict[shlist[i]])
          tdict[shlist[i]] = 0;
      ++tdict[shlist[i]];
    }
    state['options_sh'].options.flatMap(x => x['value']).forEach(x => genCS(x))
  }
} */

function controlLogic(state,action) {
  let newState = {}
  /* let option_ring_view1 = ["cec","cec2","ds","dctw","rmet","hmet","sh","headc","rsetc"]
  let option_ring_view2 = []
  let option_ring_view3 = [] */

  if (action.attr === 'sh') {
    DEFAULT_DICT = DEFAULT_ATTR_VALUE[action.value];
    /* if (!(action.value in cdict))
      genCS(action.value) */
  }
  let res_options = {}
  let preset={ 
    /*"R3":["LBT","HPS","WT","WT","S","S"],
  "R2":["AM","HCU","0","WT","S","S"],
  "R1":["WT","HCU","WT","WT","10R","10R"],
  "R12":["AQ","HECU","WT","WT","10W","10W"],
  "R6":["PZ","HCU","WT","WT","S","S"],
  "R4":["CT","HPS","WT","WT","10Y","10Y"],
  "R9":["LBT","HECU","WT","0","10R","10R"],
  "R5":["TZ","HPS","WT","WT","S","S"],
  "R7":["WT","HOV","PZ","0","10R","10R"],
  "R10":["LBT","HECU","0","WT","S","S"],
  "R11":["PZ","HCU","0","WT","10Y","10Y"],
  "P1":["LBT","HPS","WT","0","0","S"],
  "P2":["AQ","HOV","WT","0","0","10Y"],
  "P5":["WT","HCU","WT","WT","0","10R"],
  "P9":["PZ","HOV","WT","WT","0","S"],
  "P6":["AM","HRD","WT","0","0","10R"],
  "P3":["LBT","HPS","WT","0","0","10Y"],
  "P7":["AQ","HOV","WT","0","0","10R"],
  "P8":["WT","HRD","WT","LBT","0","S"],
  "E1":["LBT","HCU","WT","0","0","S"],
  "E6":["WT","HPS","WT","0","0","10R"],
  "E7":["AM","HOV","WT","0","0","10Y"],
  "E2":["PZ","HCU","WT","WT","0","S"],
  "E5":["LBT","HPS","WT","0","0","S"],
  "E3":["WT","HRD","WT","0","0","10R"],
  "E8":["LBT","HPS","WT","0","0","S"],
  "B1":["LBT","HOV","WT","0","0","S"],
  "B3":["AM","HOV","WT","0","0","10Y"],
  "B2":["WT","HCU","0","0","0","10R"],
  "B4":["PZ","HOV","WT","0","0","S"]}*/
  "R3":["LBT","HECU","WT","WT","S","S"],
"R2":["0","HPS","0","WT","S","S"],
"R1":["WT","HCU","WT","WT","10R","10R"],
"R12":["AQ","HECU","WT","WT","10W","10W"],
"R6":["PZ","HCU","WT","WT","S","S"],
"R4":["CT","HPS","WT","WT","10Y","10Y"],
"R9":["LBT","HECU","WT","0","10R","10R"],
"R5":["TZ","HPS","WT","WT","S","S"],
"R7":["WT","HOV","PZ","0","10R","10R"],
"R10":["0","HECU","0","WT","S","S"],
"R11":["PZ","HCU","0","WT","10Y","10Y"],
"P1":["0","HPS","WT","0","0","S"],
"P2":["AM","HOV","WT","0","0","10Y"],
"P5":["WT","HCU","WT","WT","0","10R"],
"P9":["PZ","HOV","WT","WT","0","S"],
"P6":["AM","HRD","WT","0","0","10R"],
"P3":["LBT","HPS","WT","0","0","10Y"],
"P7":["AQ","HOV","WT","0","0","10R"],
"P8":["WT","HRD","WT","LBT","0","S"],
"E1":["WT","HCU","WT","0","0","S"],
"E6":["LBT","HPS","WT","0","0","10R"],
"E7":["AM","HOV","WT","0","0","10Y"],
"E2":["PZ","HCU","WT","WT","0","S"],
"E5":["LBT","HPS","WT","0","0","S"],
"E3":["WT","HRD","WT","0","0","10R"],
"E8":["0","HECU","WT","0","0","S"],
"B1":["PZ","HOV","WT","0","0","S"],
"B3":["0","HPS","WT","0","0","10Y"],
"B2":["WT","HCU","0","0","0","10R"],
"B4":["LBT","HRD","WT","0","0","S"]}
//console.log('new action',window.testAB,action.attr, action.value)
 

  if (action.attr === 'sh' && (window.testAB==='B' || window.testAB==='C' )) {
    var av= preset[action.value]
          newState['cec']=av[0]
          newState['ds']=av[1]
          if (action.value==='B2'){
            newState['cec2']=av[0]
          }
        //  else  {
            newState['headc']=av[2]
            newState['rsetc']=av[3]
        //  }  

          newState['hmet']=av[4]
          newState['rmet']=av[5]
          newState['dctw']='1'
        } 

          if (action.attr === 'sh' && window.testAB!=='B'  && window.testAB!=='C') {
  //          console.log('new action',action.attr, action.value)
            //if (newState['cec2']==='0'){newState['cec2']='WT'}
              if (state['headc']==='0'){newState['headc']='WT'}
              if (state['rsetc']==='0'){newState['rsetc']='WT'}
  }

 // console.log('s1',newState['options_sh'],state)

  
  /* if (tdict === undefined) {
    tdict = {}
    var shlist = state['options_sh'].options.flatMap(x => x['value'].substring(0,1))
    for(var i = 0; i < shlist.length; ++i) {
      if(!tdict[shlist[i]])
          tdict[shlist[i]] = 0;
      ++tdict[shlist[i]];
    }
  } */

  /* console.log(state.sku,DEFAULT_K_SKU,state.sh)
  if (state.sku !== DEFAULT_K_SKU && state.sh !== undefined && state['crossprice'] === undefined) {
    if (!(state.sh in cdict))
      genCS(state.sh)
    genCrossSell(state)
    console.log(cdict,state.crossprice)
  } */
  
  // main logic to update  available options based on style json 
  // with attribute effect_attr and effect_value in options with type 'control'
  // see template in admin-internal-template

  if (state.hasOwnProperty('options_all') && state['options_all'].indexOf(action.attr) !== -1) {
    if (state['options_'+action.attr].type === 'control') {
       let options = state['options_' + action.attr].options
       for (let i in options){
         if (options[i].value.toString() === action.value.toString()) {
          let option = options[i].effect
          for (let j in option) {
           if (option[j].hasOwnProperty('option')){
            for (let l in option[j].optionSet) {
              if (!res_options.hasOwnProperty(option[j].optionSet[l])){
                res_options[option[j].optionSet[l]] = state['options_' + option[j].optionSet[l]]
              }  
              for (let k in option[j].option) {
               for (let m in res_options[option[j].optionSet[l]].options) {
                if  (res_options[option[j].optionSet[l]].options[m].value === option[j].option[k]) {
                  if (!option[j].hasOwnProperty('if_attr'))
                  {
                  if (DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l]) && option[j].effect_attr === 'show' && option[j].effect_value === false)
                   {
                      res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] = option[j].effect_value
                      if (state[option[j].optionSet[l]] === option[j].option[k])
                       {
                      newState[option[j].optionSet[l]] = DEFAULT_DICT[option[j].optionSet[l]]
                      if (option[j].optionSet[l] === 'rset'){
                        res_options['rsetc'] = state['options_rsetc']
                        res_options['rsetc']['show'] = false
                        newState['rsetc'] = DEFAULT_DICT['rsetc']
                      }
                      if (option[j].optionSet[l] === 'ren')
                        newState['renl'] = DEFAULT_DICT['renl']
                      }
                  }
                  else if (DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l]) && option[j].effect_attr === 'show' && option[j].effect_value === true)
                   {
                      res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] = option[j].effect_value

                    if (option[j].optionSet[l] === 'rset'){
                      newState['rsetc']=DEFAULT_DICT['rsetc']
                      newState['rsetl']=DEFAULT_DICT['rsetl']
                    }
                    if (option[j].optionSet[l] === 'ren')
                      newState['renl']=DEFAULT_DICT['renl']
                  }
                }
                else {
                  if (option[j].if_value.indexOf(state[option[j].if_attr]) !== -1 && 
                  DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l]))
                  { 
                    res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] = option[j].effect_value
                     
                     if (DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l])
                     && option[j].effect_attr === 'show' && option[j].effect_value === false
                     && option[j].option.includes(state[option[j].optionSet[l]])
                     )
                      {
                     newState[option[j].optionSet[l]] = DEFAULT_DICT[option[j].optionSet[l]]
                     if (option[j].optionSet[l] === 'ren')
                       newState['renl'] = DEFAULT_DICT['renl']
                      } 
                 }
                } 
                }
               }
              }
            }  
           } 
           else {
            for (let l in option[j].optionSet) {
              if (!res_options.hasOwnProperty(option[j].optionSet[l])){
                res_options[option[j].optionSet[l]] = state['options_'+ option[j].optionSet[l]]
              }  
              if (!option[j].hasOwnProperty('if_attr'))
              { 
              res_options[option[j].optionSet[l]][option[j].effect_attr] = option[j].effect_value
                  if (DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l]) && option[j].effect_attr === 'show' && option[j].effect_value === false)
                   {
                      newState[option[j].optionSet[l]] = DEFAULT_DICT[option[j].optionSet[l]]
                  }
              }
              else {
                if (option[j].if_value.indexOf(state[option[j].if_attr]) !== -1 && DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l]))
                { 
                  res_options[option[j].optionSet[l]][option[j].effect_attr] = option[j].effect_value
                  if (DEFAULT_DICT.hasOwnProperty(option[j].optionSet[l]) && option[j].effect_attr === 'show' && option[j].effect_value === false)
                   {
                      newState[option[j].optionSet[l]] = DEFAULT_DICT[option[j].optionSet[l]]
                  }
               }
               
              } 
            }  
           }
          }
        }
      }
    }  
  }
  //console.log('s2',newState['options_sh'],state['type'])

  for (let i in res_options) {
    newState['options_'+i]=res_options[i]
  }
  //console.log('s3',newState)

  //let all_ring_options = ["type","ds","dctw","dq","cec","cec2", "head","sh", "rs", "bl", "ren", "hmet","rmet","cross1","cross2","cross3","rs2","bl2","active_view"]
 /* if (action.attr === 'rmet' && action.value === 'PT'){
    newState['rmetc'] = 'W'
    newState['hmetc'] = 'W'
    newState['bmet'] = 'PT'
    newState['bmetc'] = 'W'
  }*/

  //console.log(state.default, newState.default)

  if (action.attr === 'default' && action.value !== '') {
    Object.keys(DEFAULT_ATTR_VALUE['C' + action.value]).forEach(key => newState[key] = DEFAULT_ATTR_VALUE['C' + action.value][key])
    if (window.currentSite === 'zales') {
      newState['cec'] = 'WT'
      if ([1,4].includes(action.value))
        newState['ds'] = 'HCU'
    }
  }
  
  if (action.attr !== 'default')
    newState[action.attr] = action.value

  var newrules_sh = rules_sh(newState,state), newrules_sh_value = check_default(newrules_sh)
  if (newrules_sh !== undefined)
    newState['options_sh'] = newrules_sh

  var shvalue = '?'
  if (state.hasOwnProperty('sh'))
      shvalue = state['sh']
  if (newState.hasOwnProperty('sh'))
      shvalue = newState['sh']
  //console.log('s4',newState['options_sh'],state['type'])

  //console.log(action.attr, state.sku, shvalue, state.default)

  //console.log(state.default, newState.default)

  for (let i in newrules_sh.options) {
      if (newrules_sh.options[i].value === shvalue && newrules_sh.options[i].show !== true)
          newState['sh'] = newrules_sh_value
  }

  var newrules_headc = rules_headc(newState,state), newrules_headc_value = 'WT' //check_default(newrules_headc)
  if (newrules_headc !== undefined)
    newState['options_headc'] = newrules_headc

  var headcvalue = '?'
  if (state.hasOwnProperty('headc'))
      headcvalue = state['headc']
  if (newState.hasOwnProperty('headc'))
      headcvalue = newState['headc']

  if (DEFAULT_DICT['headc'] !== '0') {
    for (let i in newrules_headc.options) {
        if (newrules_headc.options[i].value === headcvalue && newrules_headc.options[i].show !== true)
            newState['headc'] = newrules_headc_value
    }
  }
  //console.log('s5',newState)

  var newrules_rsetc = rules_rsetc(newState,state), newrules_rsetc_value = 'WT' //check_default(newrules_rsetc)
  if (newrules_rsetc !== undefined)
    newState['options_rsetc'] = newrules_rsetc

  var rsetcvalue = '?'
  if (state.hasOwnProperty('rsetc'))
      rsetcvalue = state['rsetc']
  if (newState.hasOwnProperty('rsetc'))
      rsetcvalue = newState['rsetc']


  if (DEFAULT_DICT['rsetc'] !== '0') {
    for (let i in newrules_rsetc.options) {
        if (newrules_rsetc.options[i].value === rsetcvalue && newrules_rsetc.options[i].show !== true)
            newState['rsetc'] = newrules_rsetc_value
    }
  }

  var newrules_rmet = rules_rmet(newState,state), newrules_rmet_value = check_default(newrules_rmet)
  if (newrules_rmet !== undefined)
    newState['options_rmet'] = newrules_rmet

  var rmetvalue = '?'
  if (state.hasOwnProperty('rmet'))
      rmetvalue = state['rmet']
  if (newState.hasOwnProperty('rmet'))
      rmetvalue = newState['rmet']

  for (let i in newrules_rmet.options) {
      if (newrules_rmet.options[i].value === rmetvalue && newrules_rmet.options[i].show !== true)
          newState['rmet'] = newrules_rmet_value
  }

  var newrules_dctw = rules_dctw(newState,state), newrules_dctw_value = check_default_max(newrules_dctw)
  if (newrules_dctw !== undefined)
    newState['options_dctw'] = newrules_dctw

  var dctwvalue = '?'
  if (state.hasOwnProperty('dctw'))
      dctwvalue = state['dctw']
  if (newState.hasOwnProperty('dctw'))
      dctwvalue = newState['dctw']

  for (let i in newrules_dctw.options) {
    if (newrules_dctw.options[i].value === dctwvalue && newrules_dctw.options[i].show !== true)
      newState['dctw'] = newrules_dctw_value
  }
  
  //console.log('s6',newState['hmet'],state['hmet'],state.type)

  if ((newState['hmet'] !== undefined) && state['hmet'] !== undefined && (state['hmet'].substring(0,2) !== newState['hmet'].substring(0,2))) {
    if (DEFAULT_DICT['rmet'] !== '0' && newState['hmet'] !== '0') {
      if (newState['hmet'] !== 'S') {
        if (state['hmet'] === 'S')
          newState['rmet'] = newState['hmet']
        else if (state['rmet'] !== 'S')
          newState['rmet'] = state['rmet'].replace(state['rmet'].substring(1,2),newState['hmet'].substring(1,2))
      }
      else
        newState['rmet'] = newState['hmet']
    }
  }

  
  //console.log('s7',newState)

  //console.log(state.default, newState.default)

  if (action.attr === 'default' && action.value !== '') {
  //  console.log('s71',newState)

    newState.default = ''
    newState['sh'] = DEFAULT_ATTR_VALUE['C' + action.value]['sh']
    newState['dctw'] = DEFAULT_ATTR_VALUE['C' + action.value]['dctw']
    newState['headc'] = DEFAULT_ATTR_VALUE['C' + action.value]['headc']
    newState['rsetc'] = DEFAULT_ATTR_VALUE['C' + action.value]['rsetc']
    newState['hmet'] = DEFAULT_ATTR_VALUE['C' + action.value]['hmet']
    newState['rmet'] = DEFAULT_ATTR_VALUE['C' + action.value]['rmet']
    //Object.keys(DEFAULT_ATTR_VALUE['C' + action.value]).forEach(key => newState[key] = DEFAULT_ATTR_VALUE['C' + action.value][key])
  }
  else if (true) {
 //   let slist = state['options_sh'].options.flatMap(x => x['value'])
 //   console.log('s72',newState)

    if (action.attr === 'type' && action.value === 'R'  ){ //&& (!slist.filter(x => x.substring(0,1) === 'R').includes(state['sh']) || state['type'] === '0')){
      newState['active_view'] = 1
      newState['sh'] = 'R3'
      //newState['cec'] = 'WT'
      DEFAULT_DICT = DEFAULT_ATTR_VALUE['R3'];
      Object.keys(DEFAULT_DICT).forEach(key => newState[key] = DEFAULT_DICT[key])
   //   console.log('s720',newState)
    }
    else if (action.attr === 'type' && action.value === 'P' ){ //&& !slist.filter(x => x.substring(0,1) === 'P').includes(state['sh'])){
      newState['active_view'] = 1
      newState['sh'] = 'P1'
      //newState['cec'] = 'WT'
      DEFAULT_DICT = DEFAULT_ATTR_VALUE['P1'];
      Object.keys(DEFAULT_DICT).forEach(key => newState[key] = DEFAULT_DICT[key])
    }
    else if (action.attr === 'type' && action.value === 'E' ){ //&& !slist.filter(x => x.substring(0,1) === 'E').includes(state['sh'])){
      newState['active_view'] = 1
      newState['sh'] = 'E1'
      //newState['cec'] = 'WT'
      DEFAULT_DICT = DEFAULT_ATTR_VALUE['E1'];
      Object.keys(DEFAULT_DICT).forEach(key => newState[key] = DEFAULT_DICT[key])
    }
    else if (action.attr === 'type' && action.value === 'B' ){ //&& !slist.filter(x => x.substring(0,1) === 'B').includes(state['sh'])){
      newState['active_view'] = 1
      newState['sh'] = 'B1'
      //newState['cec'] = 'WT'
      DEFAULT_DICT = DEFAULT_ATTR_VALUE['B1'];
      Object.keys(DEFAULT_DICT).forEach(key => newState[key] = DEFAULT_DICT[key])
    }
   // else if (action.attr === 'sh') {
   //   newState['active_view'] = 1
   //   Object.keys(DEFAULT_DICT).forEach(key => newState[key] = DEFAULT_DICT[key])
   // }
  }
  if (action.attr === 'sh' && window.testAB!=='B'&& window.testAB!=='C') {
    //console.log('s73',newState)

    newState['active_view'] = 1
    newState.cross1 = 0
    newState.cross2 = 0
    newState.cross3 = 0
    var garr1 = ['D','WT','CT','PZ','AM','GA','PT','SAP','EM','RU']
    var garr2 = ['WT','AQ','CT','PZ','LBT','AM','MG','TZ','PT']
    Object.keys(DEFAULT_DICT).forEach(key => {
      if (DEFAULT_DICT[key] === '0') {
        newState[key] = '0';
      }
      else {
        if (state.type === 'B') {
          if (key === 'cec2' && state['cec2'] === '0') {
            if (state['headc'] !== '0' && garr2.includes(state['headc']))
              newState['cec2'] = state['headc']
            else
              newState['cec2'] = 'WT'
          }
          else if (key === 'headc' && state['headc'] === '0') {
       //     console.log('s74',newState)

            if (!alt.includes(action.value)) {
              if (state['cec2'] !== '0' && garr1.includes(state['cec2']))
                newState['headc'] = state['cec2']
              else
                newState['headc'] = 'WT'
            }
            else {
              if (state['cec2'] !== '0' && garr2.includes(state['cec2']))
                newState['headc'] = state['cec2']
              else
                newState['headc'] = 'WT'
            }
          }
        }
        else {
      //    console.log('s75',newState)

          if (key === 'headc') {
            if (!alt.includes(action.value)) {
              if (state['headc'] !== '0' && garr1.includes(state['headc']))
                newState['headc'] = state['headc']
              else if (state['headc'] === '0' && state['rsetc'] !== '0' && garr1.includes(state['rsetc']) && DEFAULT_DICT['rsetc'] === '0')
                newState['headc'] = state['rsetc']
              else
                newState['headc'] = 'WT'
            }
            else {
              if (state['headc'] !== '0' && garr2.includes(state['headc']))
                newState['headc'] = state['headc']
              else if (state['headc'] === '0' && state['rsetc'] !== '0' && garr2.includes(state['rsetc']) && DEFAULT_DICT['rsetc'] === '0')
                newState['headc'] = state['rsetc']
              else
                newState['headc'] = 'WT'
            }
          }
          else if (key === 'rsetc') {
            if (!alt2.includes(action.value)) {
              if (state['rsetc'] !== '0' && garr1.includes(state['rsetc']))
                newState['rsetc'] = state['rsetc']
              else if (state['rsetc'] === '0' && state['headc'] !== '0' && garr1.includes(state['headc']) && DEFAULT_DICT['headc'] === '0')
                newState['rsetc'] = state['headc']
              else
                newState['rsetc'] = 'WT'
            }
            else {
              if (state['rsetc'] !== '0' && garr2.includes(state['rsetc']))
                newState['rsetc'] = state['rsetc']
              else if (state['rsetc'] === '0' && state['headc'] !== '0' && garr2.includes(state['headc']) && DEFAULT_DICT['headc'] === '0')
                newState['rsetc'] = state['headc']
              else
                newState['rsetc'] = 'WT'
            }
          }
        }
      }
    })
  }
  //console.log('s8',newState)

  /* if (['type', 'sh'].includes(action.attr)) {
    newState['cross1'] = 0
    newState['cross2'] = 0
    newState['cross3'] = 0
    newState['rs2'] = '0'
    newState['bl2'] = '0'
  } */

  if ((action.attr === 'type' && action.value === 'B') || (state['type'] === 'B')) {
    if (state['max_view'] !== 1) {
      newState['max_view'] = 1
      newState['active_view'] = 1
    }
  }
  else if ((action.attr === 'type' && action.value === 'E') || (state['type'] === 'E')) {
    if (state['max_view'] !== 2) {
      newState['max_view'] = 2
      newState['active_view'] = 1
    }
  }
  else {
    if (state['max_view'] !== 3) {
      newState['max_view'] = 3
    }
  }

  if (action.attr === 'cross1') {
    if ([1,2].includes(action.value))
      newState['active_view'] = state['max_view'] + 1
    else
      newState['active_view'] = 1
  }
  else if (action.attr === 'cross2') {
    if ([1,2].includes(action.value)) {
      if ([1,2].includes(state['cross1']) || [1,2].includes(newState['cross1']))
        newState['active_view'] = state['max_view'] + 2
      else
        newState['active_view'] = state['max_view'] + 1
    }
    else
      newState['active_view'] = 1
  }
  else if (action.attr === 'cross3') {
    if ([1,2].includes(action.value)) {
      if (([1,2].includes(state['cross1']) || [1,2].includes(newState['cross1'])) && ([1,2].includes(state['cross2']) || [1,2].includes(newState['cross2'])))
        newState['active_view'] = state['max_view'] + 3
      else if ([1,2].includes(state['cross1']) || [1,2].includes(newState['cross1']) || [1,2].includes(state['cross2']) || [1,2].includes(newState['cross2']))
        newState['active_view'] = state['max_view'] + 2
      else
        newState['active_view'] = state['max_view'] + 1
    }
    else
      newState['active_view'] = 1
  }
  else if (["type", "sh", "ds", "dctw", "cec", "cec2", "headc", "rsetc", "hmet", "rmet"].includes(action.attr)) {
    newState['active_view'] = 1
  }
  //console.log('s9',newState)
 
//console.log('newstate',state.headc,state.rsetc,newState.headc,newState.rsetc)
  return newState
}

export default function reducer(state = INITIAL_STATE, action) {
 // console.log('REDUCER',state.sku, action.type, action.attr, action.value, state.initzalessku) //state)
  if (action.attr !== undefined && action.value === state['action.attr']) {
    return state
  }
   var all_dynamic_options = ['type','ce','cec','cec2','ds','dctw','head', 'headc','sh',
   'pkb','pkbc','rset','rsetc','rsetl','ren','renl','bset',
   'bsetc','rmet',"hmet","dct",
   'bmet','bmetc','rs','bl',"dq","loading","isposterminal", "cross1", "cross2", "cross3", 'rs2', 'bl2', "active_view",'default']
   var all_cust_options = ["ds", "dctw", "cec", "cec2", "headc", "rsetc", "hmet", "rmet"]
    var newState
    var newState2
    var refParam
    switch (action.type) {
      case 'REDUX-LOCATION-POP-ACTION':
       if (action.object !== undefined)
       {
        let refParam = sku2array(action.object['sku']) 
        for (let i in refParam )
        {
         action.object[i]= refParam[i]
        }
       }
       return  Object.assign({}, state, {...action.object});      
      case ACTIONS.START_OVER:
        //changed = false
        //state['default'] = ''
        //state['initial'] = 'yes'
        state['title'] = ''
        var json2 = JSON.parse(JSON.stringify(state.start_over_init));
        //json2['showReview'] =false
        //json2['sku']=get_default_sku()
        if (window.testAB==="C"){
          json2['sku']=''//get_default_sku2()
          json2['initial']='yes'
          json2['type']='0'
      }
        else
        {
        json2['sku']=state.initialSku//get_default_sku2()
        
        //refParam = sku2array(get_default_sku()) 
        refParam = sku2array(state.initialSku)
        //get_default_sku2()) 
        for (let i in refParam )
        {
         json2[i]= refParam[i]
        }
        //json2['er'] =''
        //json2['loading'] ='new'
        //json2['eb1'] =''
      }
        return  Object.assign({}, state, {...START_OVER_STATE,...json2});
        case ACTIONS.ZALESSKU:
            newState=state
             newState['sku']=action.object.value
             newState['cfg1']= action.object.value
             newState['zalessku']= ''
      //      console.log('s00',newState)
             refParam = sku2array(action.object.value) 
             for (let i in refParam )
             {
               newState[i]= refParam[i]
             }
             newState2={};
             var i;
             for (i in all_dynamic_options)
             if (newState.hasOwnProperty(all_dynamic_options[i]))
               {
                let val={attr:all_dynamic_options[i],value:newState[all_dynamic_options[i]]}
              newState2= controlLogic(newState,val);
              }
            
             return  Object.assign({}, state, {...newState,...newState2});
     case ACTIONS.HISTORY:
      /* if (Object.keys(cdict).length === 0) {
        initCS(state)
      } */

      //if (state.zalessku !== '' ){return state}
      if (state.initial !=='yes'){
      newState=state
       newState['sku']=action.value
       newState['cfg1']= action.value
     
       refParam = sku2array(action.value) 
       for (let i in refParam )
       {
         newState[i]= refParam[i]
       }
 
       newState2={};
       
       for (i in all_dynamic_options)
       if (newState.hasOwnProperty(all_dynamic_options[i]))
         {
          let val={attr:all_dynamic_options[i],value:newState[all_dynamic_options[i]]}
        newState2= controlLogic(newState,val);
        }
    //    if (state['er'] !==''){
          newState2['loading-ring'] ='new'
      //  }   
      
        if (crosssku === undefined)
          genCrossSell(state)

       return  Object.assign({}, state, {...newState,...newState2});      
      }
      else
      return  state;      
      
      case ACTIONS.LOAD_JSON:
        if (state.initial !== 'yes') {
          changed = true //false //true
        }
        
        state.json='loaded'
     //   console.log('s02',action.object['options_sh']['show'])
            
        let options = action.object['options_all']

        for (let i in options ){
          let defaultValue = DEFAULT_STATE_VALUE
          if (options[i] ==='f') {
            defaultValue = '0'
          }
          if ( !['cross1','cross2','cross3','rs2','bl2'].includes(options[i])) {
            //console.log(options[i],state[options[i]])
            if (state.hasOwnProperty(options[i]) !== DEFAULT_STATE_VALUE) {
              let correctValue = false
              for (let j in action.object['options_'+options[i]].options) {
                 if  (action.object['options_'+options[i]].options[j].value === state[options[i]]){
                   correctValue =true
                   break
                 }
              }
              if (correctValue === false) {
                state[options[i]]=defaultValue
              }
            }
          }
          else {
          for (let j in action.object['options_'+options[i]].options) {
             let type = 'engraving'

             if (action.object['options_'+options[i]].options[j].hasOwnProperty('filter')){
                type=action.object['options_'+options[i]].options[j]['filter']
             }   
             state[action.object['options_'+options[i]].options[j].attr] =filter(state[action.object['options_'+options[i]].options[j].attr],
             type,action.object['options_'+options[i]].options[j].maxLength)
          }
        }
        }
          if (action.object['showReview'] === false)
            for (let i in options) {
              if (options[i] !== 'e' && options[i] !== 'f' && state[options[i]] !== DEFAULT_STATE_VALUE) {
                action.object['showReview'] = true
              break
            }
        }
        if (state.initial !== 'yes')
                if (action.object['sku'] !== undefined && action.object['sku'] !== state.sku) {
          refParam = sku2array(action.object['sku']) 
          for (let i in refParam) {
            action.object[i] = refParam[i]
          }
        } 
        //action.object['active_view'] = 1
        newState={};
        if (state.initial !== 'yes')
        
        for (i in all_dynamic_options) {
          if (action.object.hasOwnProperty(all_dynamic_options[i])) {
            let val = {attr:all_dynamic_options[i], value:action.object[all_dynamic_options[i]]}
            newState = controlLogic(action.object,val);
          }
        }
       // console.log('s02a',newState['options_sh'])
        if (state.initial === 'yes'){
          newState['sku']=''
          newState['initialSku']=''
          if (window.testAB==='C')
          newState['type']='0'
       //   newState['type']='0'

        }
       // newState['type']='0'
      //  console.log('s01',newState,state)
            
        /* if (action.object['isposterminal'] === 'true' || state['isposterminal'] === 'true') {
          let getOp = action.object['options_ud']
          getOp['show'] = true
          newState['options_ud'] = getOp
        }*/
        //console.log(state, newState)
        
        /* if (Object.keys(cdict).length === 0) {
          initCS(newState)
        } */
        if (state.sku !== undefined)
          genCrossSell(state)

        return  Object.assign({}, state, {...newState,...action.object});      
      case ACTIONS.FORCE_UPDATE:
        newState={};
        newState2= controlLogic(state,action,newState2);
          newState[action.attr]=action.value
         return  Object.assign({}, state, {...newState, ...newState2});

       case ACTIONS.UPDATE:
        if (action.attr === 'type') {
          changed = true
        }
        else if (all_cust_options.includes(action.attr)) {
          changed = true //false //true
        }
        newState={};
        newState2= controlLogic(state,action);
    
        if (action.attr === "message"){
          newState={'message':''}
          }
  if (action.attr === "rs" && action.value !== '0'){
                newState={'message':''}
                }
                
              if (state[action.attr] !==action.value){
          newState[action.attr]=action.value
          let resObj = Object.assign({}, state, {...newState, ...newState2}); 

          if (all_dynamic_options.indexOf(action.attr) !== -1) {
          var state1 ={}
          state1['type']=checkNewValue(state,newState2,'type')
          state1['cec']=checkNewValue(state,newState2,'cec')
          state1['cec2']=checkNewValue(state,newState2,'cec2')
          state1['ds']=checkNewValue(state,newState2,'ds')
          state1['dctw']=checkNewValue(state,newState2,'dctw')
          state1['headc']=checkNewValue(state,newState2,'headc')
          state1['rsetc']=checkNewValue(state,newState2,'rsetc')
          state1['hmet']=checkNewValue(state,newState2,'hmet') 
          state1['rmet']=checkNewValue(state,newState2,'rmet')
          if (checkNewValue(state,newState2,'rs2') !== '0') {
            state1['rs']=checkNewValue(state,newState2,'rs2')
          }
          else {
            state1['rs']=checkNewValue(state,newState2,'rs')
          }
          if (checkNewValue(state,newState2,'bl2') !== '0') {
            state1['bl']=checkNewValue(state,newState2,'bl2')
          }
          else {
            state1['bl']=checkNewValue(state,newState2,'bl')
          }
          state1['store']=checkNewValue(state,newState2,'store')
          state1['sh']=checkNewValue(state,newState2,'sh')

          //console.log('state1',state1)

          state1[action.attr]=action.value

          var newsku=param2sku(
            [state1['type'],state1['cec'],state1['cec2'],state1['ds'],state1['dctw'],state1['headc'],state1['rsetc'],state1['hmet'],state1['rmet'],state1['rs'],state1['bl'],state1['store'],state1['sh']])
            resObj['sku']= newsku[0]
            resObj['cfg1']= newsku[0]
            resObj['sku-error']= newsku[1]   

            state1['sku']=newsku[0]

            if (state1.sku !== undefined)
              genCrossSell(state1)   
            }

          return resObj  
        }

        if (state.sku !== undefined)
          genCrossSell(state)

       return state
      default:
        return state
    }
    
}


// WEBPACK FOOTER //
// ./src/reducers/reducer.js